import { IAction } from '@/store/types/action'
import { IState, ITranscoHyperProxi } from './types'
import transcoHyperProxi from '.'
import { getApi } from '@/api'
import {
  ITranscoHyperProxiRequest,
  IPatchTranscoHyperProxiRequest,
} from '@/api/types/requests/transco-hyper-proxi'
import {
  GET_TRANSCO_HYPER_PROXI_INIT,
  GET_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_TRANSCO_HYPER_PROXI_ERROR,
  GET_TRANSCO_HYPER_PROXI_PRODUCT_INIT,
  GET_TRANSCO_HYPER_PROXI_PRODUCT_SUCCESS,
  GET_TRANSCO_HYPER_PROXI_PRODUCT_ERROR,
  GET_CREATED_TRANSCO_HYPER_PROXI_INIT,
  GET_CREATED_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_CREATED_TRANSCO_HYPER_PROXI_ERROR,
  GET_MODIFY_TRANSCO_HYPER_PROXI_INIT,
  GET_MODIFY_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_MODIFY_TRANSCO_HYPER_PROXI_ERROR,
  GET_DELETE_TRANSCO_HYPER_PROXI_INIT,
  GET_DELETE_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_DELETE_TRANSCO_HYPER_PROXI_ERROR,
  UPDATE_PROVIDER_SEARCH,
  UPDATE_PRODUCT_SEARCH,
} from './mutations-types'

const searchProviders: IAction<IState, string> = async ({ commit }, query) => {
  commit(GET_TRANSCO_HYPER_PROXI_INIT)
  const api = getApi()
  try {
    const response = await api.TranscoHyperProxi.searchProviders(query)
    commit(GET_TRANSCO_HYPER_PROXI_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while searching for Providers', error)
    commit(GET_TRANSCO_HYPER_PROXI_ERROR, { error })
  }
}

const updateProviderSearch: IAction<IState, string> = async (
  { commit },
  query,
) => {
  commit(UPDATE_PROVIDER_SEARCH, query)
}

const searchProducts: IAction<IState, string> = async ({ commit }, query) => {
  commit(GET_TRANSCO_HYPER_PROXI_PRODUCT_INIT)
  const api = getApi()
  try {
    const response = await api.TranscoHyperProxi.searchProducts(query)
    commit(GET_TRANSCO_HYPER_PROXI_PRODUCT_SUCCESS, response)
  } catch (error) {
    console.error(
      'An error occurred while searching TRANSCO_HYPER_PROXY_PRODUCT',
      error,
    )
    commit(GET_TRANSCO_HYPER_PROXI_PRODUCT_ERROR, { error })
  }
}

const updateProductSearch: IAction<IState, string> = async (
  { commit },
  query,
) => {
  commit(UPDATE_PRODUCT_SEARCH, query)
}

const getAll: IAction<IState, any> = async ({ commit }) => {
  commit(GET_TRANSCO_HYPER_PROXI_INIT)

  const api = getApi()

  try {
    const response = await api.TranscoHyperProxi.getAll()
    commit(GET_TRANSCO_HYPER_PROXI_SUCCESS, response)
  } catch (error) {
    console.error(
      'An error occurred while fetching TRANSCO_HYPER_PROXY',
      error,
    )
    commit(GET_TRANSCO_HYPER_PROXI_ERROR, { error })
  }
}

const getAllTranscoHyperProxisProducts: IAction<IState, any> = async ({
  commit,
}) => {
  commit(GET_TRANSCO_HYPER_PROXI_PRODUCT_INIT)

  const api = getApi()

  try {
    const response = await api.TranscoHyperProxi.getAllTranscoHyperProxisProducts()
    commit(GET_TRANSCO_HYPER_PROXI_PRODUCT_SUCCESS, response)
  } catch (error) {
    console.error(
      'An error occurred while fetching TRANSCO_HYPER_PROXY_PRODUCT',
      error,
    )
    commit(GET_TRANSCO_HYPER_PROXI_PRODUCT_ERROR, { error })
  }
}

const putTransco: IAction<IState, any> = async (
  { commit, dispatch },
  item: ITranscoHyperProxiRequest,
) => {
  commit(GET_CREATED_TRANSCO_HYPER_PROXI_INIT)

  const api = getApi()

  try {
    const response = await api.TranscoHyperProxi.putTransco(item)
    commit(GET_CREATED_TRANSCO_HYPER_PROXI_SUCCESS, response)
  } catch (error) {
    console.error(
      'An error occurred while fetching TRANSCO_HYPER_PROXY',
      error,
    )
    commit(GET_CREATED_TRANSCO_HYPER_PROXI_ERROR, { error })
  }
}

const patchTransco: IAction<IState, any> = async (
  { commit, dispatch },
  item: ITranscoHyperProxiRequest,
) => {
  commit(GET_MODIFY_TRANSCO_HYPER_PROXI_INIT)

  const api = getApi()

  try {
    const response = await api.TranscoHyperProxi.patchTransco(item)
    commit(GET_MODIFY_TRANSCO_HYPER_PROXI_SUCCESS, response)
  } catch (error) {
    console.error(
      'An error occurred while fetching TRANSCO_MODIFY_HYPER_PROXY',
      error,
    )
    commit(GET_MODIFY_TRANSCO_HYPER_PROXI_ERROR, { error })
  }
}

const deleteTransco: IAction<IState, any> = async (
  { commit, dispatch },
  item: any,
) => {
  commit(GET_DELETE_TRANSCO_HYPER_PROXI_INIT)

  const api = getApi()
  try {
    await api.TranscoHyperProxi.deleteTransco({
      hyperCode: item.hyperCode,
      proxiCode: item.proxiCode,
    })
    commit(GET_DELETE_TRANSCO_HYPER_PROXI_SUCCESS, item)
  } catch (error) {
    console.error(
      'An error occurred while fetching TRANSCO_DELETE_HYPER_PROXY',
      error,
    )
    commit(GET_DELETE_TRANSCO_HYPER_PROXI_ERROR, { error })
  }
}

export default {
  searchProviders,
  updateProviderSearch,
  searchProducts,
  updateProductSearch,
  getAll,
  getAllTranscoHyperProxisProducts,
  patchTransco,
  putTransco,
  deleteTransco,
}
